import { render, staticRenderFns } from "./Project-Setting.vue?vue&type=template&id=f7d6f8fe"
import script from "./Project-Setting.vue?vue&type=script&lang=js"
export * from "./Project-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports